import React, { useEffect, useState } from 'react';
import { Modal, Form, Select, Row, Col, Typography } from 'antd';

const { Text } = Typography;
const { Option } = Select;

function ThirdPartyEditSurchargeModal({ open, setOpen, onSubmit, loading, success, surchargeList = {}, editSurchargeData}) {
    const [form] = Form.useForm();
    const [surchargeErrorJson, setSurchargeErrorJson] = useState({});

    useEffect(() => {
        if (success) {
            form.resetFields();
        }
    }, [success, form]);

    useEffect(() => {
        if (editSurchargeData && editSurchargeData.surcharge_error_json) {
            setSurchargeErrorJson(editSurchargeData.surcharge_error_json);
        }
    }, [editSurchargeData, form]);

    const handleOk = () => {
        form.validateFields().then(values => {
            const updatedMappings = Object.keys(values).map(key => {
                return {
                    "mapped_name": values[key],
                    "target_name": key
                };
            });

            const submitData = {
                id: editSurchargeData.id,
                sur: updatedMappings
            };

            onSubmit(submitData);
        }).catch(error => {
            console.log(error);
        });
    };

    // 从surchargeList对象中提取所有的附加费名称
    const allSurcharges = Object.values(surchargeList).flat().map(surcharge => surcharge.name);

    return (
        <Modal
            open={open}
            onCancel={() => setOpen(false)}
            onOk={handleOk}
            centered
            confirmLoading={loading}
            width={700}
        >
            <Form form={form} layout="vertical">
                <Row gutter={16} style={{ marginBottom: '16px' }}>
                    <Col span={12}>
                        <Text strong>附加费名称</Text>
                    </Col>
                    <Col span={12}>
                        <Text strong>新附加费名称</Text>
                    </Col>
                </Row>
                {Object.keys(surchargeErrorJson).map((key) => (
                    <Row gutter={16} key={key} style={{ marginBottom: '16px' }}>
                        <Col span={12}>
                            <Text>{key}</Text>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name={key}
                                rules={[{ required: true, message: '请选择映射的附加费' }]}
                            >
                                <Select
                                    placeholder="请选择"
                                    showSearch
                                    options={allSurcharges.map(surchargeName => ({
                                        label: surchargeName,
                                        value: surchargeName
                                    }))}
                                    filterOption={(input, option) =>
                                        option.label.toLowerCase().includes(input.toLowerCase())
                                    }
                                    />
                            </Form.Item>
                        </Col>
                    </Row>
                ))}
            </Form>
        </Modal>
    );
}

export default ThirdPartyEditSurchargeModal;
